var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 76,
    viewBox: "0 0 48 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9718 73H14.457V59.5212C10.638 56.0766 3 48.6033 3 46.267C3 43.3466 5.69576 36.6072 8.84082 33.9114C9.4558 33.3843 10.4133 33.4621 11.5366 33.9114C12.4352 34.2708 21.1215 38.1539 25.4647 40.1008C26.5879 40.6999 27.7112 42.2233 26.3633 43.2459C24.1208 44.9472 21.8703 46.9409 19.6239 46.267C17.8267 45.7278 14.0826 44.0954 12.4352 43.3466",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96411 33.4622V25.8242C9.96411 24.5512 10.7728 22.0501 14.0078 22.2298C17.2427 22.4095 18.2012 24.4014 18.276 25.3749V36.8319",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.276 36.8319V25.1502C18.8002 24.027 20.4326 21.7805 22.769 21.7805C25.6894 21.7805 26.8126 25.3749 26.8126 25.8241C26.8126 26.1836 26.8126 36.5323 26.8126 41.5494",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0373 38.8537V25.8241C27.4866 24.9256 29.1497 24.027 30.6316 24.027C33.5521 24.027 34.4506 25.3749 34.8999 26.2734C35.0497 29.9427 35.2594 37.4609 34.8999 38.1797C34.4506 39.0783 33.3274 40.8755 30.8563 41.1001C28.8794 41.2799 27.4866 39.6774 27.0373 38.8537Z",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3492 40.6508V27.6213C35.7985 26.7227 37.4615 25.8241 38.9435 25.8241C41.8639 25.8241 42.7625 27.172 43.2118 28.0706C43.3616 31.7398 43.344 38.9595 43.2118 39.7522C42.9872 41.1001 41.6393 42.6726 39.1682 42.8973C37.1913 43.077 35.3492 41.5494 35.3492 40.6508Z",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2119 39.9769C43.0621 42.448 42.6278 47.6598 42.0887 48.7382C41.5495 49.8165 40.0668 56.2264 39.3929 59.2966C39.318 59.671 39.1682 60.6894 39.1682 61.7677C39.1682 62.846 39.1682 69.7052 39.1682 73H20.7472",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.421 46.267C23.4428 48.2888 27.3966 53.7253 27.0372 59.2965",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26831 8.12195L12.3903 14.0976",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4651 8.12195L41.0779 14.656",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9024 3V11.5366",
    stroke: "#3486A0",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9352584cb2250c14f0837635cfeb70b5.svg";
export { ForwardRef as ReactComponent };